const readFileContent = (file: Blob): Promise<ArrayBuffer> => {
  const promise = new Promise<ArrayBuffer>((resolve) => {
    const reader = new FileReader();

    reader.onload = () => {
      const content = reader.result as ArrayBuffer;

      resolve(content);
    };

    reader.readAsArrayBuffer(file);
  });

  return promise;
};

export default readFileContent;
